import React from 'react';

import './styles.scss';

import {end} from '../../utils/beforeunload';
import strings from '../../utils/strings';
import ferdigLydDe from '../../assets/sounds/adult/de/testen-er-ferdig.mp3';
import AudioPlayer from '../AudioPlayer';
import avatar from '../../assets/images/avatar.png';

class Ferdig extends React.Component {
	componentDidMount() {
		end();
		window.localStorage.removeItem('authtoken-screening');
	}

	render() {
		const isGerman = strings.getLanguage() === 'de';

		return (
			<div>
				<h1 className="lit-page-title">{strings.done}</h1>

				{isGerman && (
					<p className="lit-page-description">
						{' '}
						<AudioPlayer autoplay inline src={ferdigLydDe} />
						{strings.doneCongrats}
					</p>
				)}

				{!isGerman && (
					<p className="lit-page-description">
						{' '}
						{strings.doneCongrats}
					</p>
				)}

				{isGerman && (
					<div className="ferdig-screening">
						<p className="ferdig-screening__intro">
							Vielen Dank für Ihre Teilnahme am Screening!
						</p>

						<div className="ferdig-screening__row">
							<div className="ferdig-screening__content">
								<p className="ferdig-screening__body">
									Wir laden Sie herzlich ein, auch am zweiten Testteil (Follow-Up)
									teilzunehmen. Dieser Testteil wird zu einem vereinbarten Termin
									individuell mit einer testleitenden Person aus unserem Team
									durchgeführt. Bitte tragen Sie sich unter folgendem Link für
									einen Termin ein:
								</p>
								<a
									className="ferdig-screening__link"
									href="https://koalendar.com/e/dysmate-a-follow-up?month=2026-10&duration=45&date=2026-10-31"
									target="_blank"
									rel="noopener noreferrer"
								>
									Dysmate-A - Follow-Up | DFN-Terminplaner
								</a>
								<p className="ferdig-screening__body">
									Wir würden uns sehr freuen, Sie bei der Follow-Up-Teilnahme
									kennenzulernen!
								</p>
							</div>
							<div className="ferdig-screening__avatar">
								<img src={avatar} alt="Dysmate Team" />
							</div>
						</div>

						<p className="ferdig-screening__closing">
							Vielen Dank &amp; herzliche Grüße im Namen des Dysmate-Teams,
							<br />
							Marie-Christine Vierbuchen, Andrea Anderson &amp; Rebecca Schumacher
						</p>

						<div className="ferdig-screening__actions">
							<button
								className="lit-btn bg-primary"
								onClick={() => {
									window.location.href = '/';
								}}
							>
								Zur Startseite
							</button>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default Ferdig;
